import { motion } from "framer-motion";
import { WHY_CHOOSE } from "../../data/content";
import { SectionHeading, Reveal } from "../primitives";

export default function WhyChoose() {
  return (
    <section data-testid="why-choose" className="relative mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHeading
        eyebrow="Why Nova SecureNet"
        title="Technology, without the complexity"
        sub="We remove the jargon and the guesswork — so you get professional results and a partner you can rely on for the long run."
      />

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {WHY_CHOOSE.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.08}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm"
            >
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-brand/10 blur-2xl transition-opacity duration-300 group-hover:opacity-100 opacity-0" />
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-brand-gradient shadow-[0_8px_24px_-8px_rgba(255,90,54,0.7)]">
                <f.icon className="h-6 w-6 text-white" strokeWidth={2} />
              </span>
              <h3 className="mt-6 font-heading text-lg font-semibold text-white">{f.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
